import { handleSecureAjaxError } from "../utils/SecurePlatformAPIUtils";
import { getGraphQLClient } from "../clients/GraphQLClient";
import { REVIEW_MESSAGE } from "./queries/MessageReviewMutations";
export const completeReview = (message, reviewPayload, callback) => {
  const graphQLClient = getGraphQLClient();
  const isEscalationReview = Object.keys(reviewPayload.escalation).length !== 0;
  const reviewVariables = {
    review: {
      messageId: message.messageId
    }
  };
  if (isEscalationReview) {
    const dialogueId = Object.keys(reviewPayload.escalation)[0];
    reviewVariables.review.escalation = {
      escalationDialogueId: dialogueId,
      agree: reviewPayload.escalation[dialogueId] === "agree" ? true : false
    };
    if (Object.keys(reviewPayload.dialogues).length !== 0) {
      reviewVariables.review.votedDialogueIds = Object.keys(reviewPayload.dialogues);
    }
  } else {
    reviewVariables.review.votedDialogueIds = Object.keys(reviewPayload.dialogues);
  }
  graphQLClient.mutate({
    mutation: REVIEW_MESSAGE,
    variables: reviewVariables
  }).then(response => {
    const message = response.data.reviewMessage;
    callback(message);
  }).catch(error => {
    handleSecureAjaxError(error, "MessageReviewActions completeReview");
    callback({
      hasError: true,
      error
    });
  });
};